
import { Vue, Options } from "vue-class-component";
import Print from "@/app/ui/views/incoming-process/sti-dest-sc/component/modules/generate.vue";
import { StiDestScController } from "@/app/ui/controllers/StiDestScController";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import { INCOMING_PROCESS_STI_DEST_SC } from "@/app/infrastructures/misc/RolePermission";
import debounce from "lodash/debounce";
import EmptyState from "@/app/ui/components/empty-list/index.vue";

@Options({
  components: {
    Print,
    EmptyState,
  },
  computed: {
    getTitle() {
      return this.$t(this.$route.meta.title);
    },
    ableToCreate() {
      return checkRolePermission(INCOMING_PROCESS_STI_DEST_SC.CREATE);
    },
  },
})
export default class StationTransitInDestSc extends Vue {
  refs: any = "";
  mounted() {
    this.refs = this.$refs.print;
  }

  fetchStiDestScList() {
    StiDestScController.fetchStiDestScList();
  }

  // loading
  get isLoading() {
    return StiDestScController.isLoading;
  }

  // error cause
  get errorCause() {
    return StiDestScController.errorCause;
  }

  // filter date
  get startDate() {
    return StiDestScController.filter.startDate;
  }

  get endDate() {
    return StiDestScController.filter.endDate;
  }

  setDateRange(value: Array<any>) {
    StiDestScController.setStartDate(value[0]);
    StiDestScController.setEndDate(value[1]);
    value[0] && value[1] && this.fetchStiDestScList();
  }

  // filter search
  get searchValue() {
    return StiDestScController.filter.search;
  }

  onSearch(value: string) {
    StiDestScController.setSearch(value);
    this.fetchStiDestScList();
  }

  clearSearch() {
    StiDestScController.setSearch("");
    this.fetchStiDestScList();
  }

  // go to update sti-dest
  goToUpdate() {
    this.$router.push("/sti-dest-sc/update");
  }

  // Table
  get columns() {
    return [
      {
        name: this.$t("stiDestSc.table.columnNo"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: any, index: number) => {
          return `<div class="overflow-ellipsis text-left">${index + 1}</div>`;
        },
      },
      {
        name: this.$t("stiDestSc.table.arrivalCity"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${item.stiDestScArrivalCityName}</div>`;
        },
        tooltipHeader: () => {
          return `<div class="text-black-lp-300 font-semibold text-12px">${this.$t("stiDestSc.table.arrivalCityTooltipTitle")}</div><div class='mt-2 text-gray-lp-500 text-12px'>${this.$t("stiDestSc.table.arrivalCityTooltipBody")}</div>`;
        },
      },
      {
        name: this.$t("stiDestSc.table.totalStt"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.stiDestScTotalStt, { type: "quantity" })}</div>`;
        }
      },
      {
        name: this.$t("stiDestSc.table.totalPieces"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.stiDestScTotalPiece, { type: "quantity" })}</div>`;
        }
      },
      {
        name: this.$t("stiDestSc.table.totalGrossWeight"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.stiDestScTotalGrossWeight, { type: "weight", suffix: " Kg" })}</div>`;
        }
      },
      {
        name: this.$t("stiDestSc.table.totalVolumeWeight"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${formatByCountry(item.stiDestScTotalVolumeWeight, { type: "weight", suffix: " Kg" })}</div>`;
        }
      },
      {
        name: this.$t("stiDestSc.table.stiDestScDate"),
        styleHead: "w-56 text-left",
        render: (item: any) => {
          return `<div class="text-black-lp-300">${formatDateWithoutTime(
            item.stiDestScCreatedAt,
          )}</div>
            <div class="capitalize text-gray-lp-500 text-12px">${
              item.stiDestScCreatedBy
            }</div>`;
        },
      },
      {
        name: this.$t("stiDestSc.table.action"),
        key: "actionable_column",
        styleHead: "w-32 text-left",
        showButton: () => {
          return true;
        },
      },
    ];
  }

  // custom button
  get customButton() {
    return {
      outline: true,
      title: this.$t("stiDestSc.list.print"),
      textColor: "black-lp-300",
      color: "gray-lp-400",
      small: false,
      clickFunction: (item: any) => {
        this.refs.print(item);
      },
    };
  }

  get pagination() {
    return StiDestScController.stiDestScList.pagination;
  }

  get stiDestScList() {
    return StiDestScController.stiDestScList.data;
  }

  // advance filter
  isAdvancedFilterOpened = false;
  onChangeAdvancedFilter = debounce((event) => {
    StiDestScController.setDestinationCityCode(event.cityDestinationCode);
    this.fetchStiDestScList();
  }, 500);
  onOpenedAdvancedFilter(event: any) {
    this.isAdvancedFilterOpened = event;
  }
  onResetAdvancedFilter = debounce(() => {
    StiDestScController.setDestinationCityCode("");
    this.fetchStiDestScList();
  }, 500);
  advancedFilterData: any = "";
}
